module.exports = __webpack_public_path__ + "img/II-22.24596768.svg";